// extracted by mini-css-extract-plugin
export default {"dlFileDownload":"src-js-containers-file-components-FileDownload---dlFileDownload---VoFT7"};